export default "__VITE_ASSET__Oqp_hG8J__"